<template>
  <el-select
    v-model="product"
    ref="product-selector-input"
    filterable
    :disabled="disabled"
    :remote="availableProducts === null"
    :remote-method="onProductSearch"
    :loading="productLoading"
    placeholder="Gépelj a kereséshez..."
    size="small"
    style="width: 100%;"
    value-key="id"
    @change="onProductChange"
  >
    <el-option
      v-for="p in (availableProducts || products)"
      :key="p.id"
      :value="p"
      :label="p.name"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    defaultProduct: {
      type: Object,
      default() {
        return null;
      },
      required: false,
    },
    availableProducts: {
      validator: prop => typeof prop === 'object' || prop === null,
      default() {
        return null;
      },
      required: false,
    },
  },
  data() {
    return {
      productLoading: false,
      product: {},
      products: [],
      timeout: '',
      debounceMilliseconds: 2000,
    };
  },
  mounted() {
    this.product = this.defaultProduct || {};
    this.products.push(this.product);
    this.onProductChange();
  },
  methods: {
    onProductChange() {
      this.$emit('change', this.product);
    },
    async onProductSearch(query) {
      if (query == '') {
        return
      }

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchProduct(query)
      }, this.debounceMilliseconds);
    },

    async searchProduct(query) {
      this.productLoading = true;
      this.products = await this.$store.dispatch('product/searchWithoutPackType', '?name=' + query);
      this.productLoading = false;
    }
  },
};
</script>
